export default "__VITE_ASSET__rj1RPgfq__"